var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vaw-header-layout"},[_c('div',{staticClass:"logo-wrapper"},[_c('Logo',{attrs:{"always-show":true}})],1),_c('div',{staticClass:"menu-wrapper"}),_c('div',{staticClass:"right-wrapper"},[_c('ActionItems')],1),_c('div',{staticClass:"avatar-wrapper"},[_c('VAWAvatar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }